module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n          Comprovantes\n          "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Comprovante " + _vm._s(_vm.summaryVP.idProtocolo) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "form-box margin-t20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('img', {
    staticClass: "rule-color",
    attrs: {
      "src": require("../../../../static/email/signature/rule_color.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box-toll-left"
  }, [_c('p', [_vm._v("N° VALE-PEDÁGIO: "), _c('b', [_vm._v(_vm._s(_vm.summaryVP.idProtocolo))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold upper"
  }, [_vm._v(_vm._s(_vm.summaryVP.embarcador) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.summaryVP.CPFCNPJEmbarcador)) + " ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-toll-right"
  }, [_c('p', {
    staticClass: "text-right"
  }, [_vm._v("DATA EMISSÃO: "), _c('b', [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.dataEmissao)))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold upper"
  }, [_vm._v(_vm._s(_vm.summaryVP.transportador) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.summaryVP.CNPJTransportador)) + " ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.summaryVP.idProtocoloCanc != null) ? _c('p', {
    staticClass: "title-doc-left upper"
  }, [_vm._v("protocolo cancelamento: "), _c('b', [_vm._v(_vm._s(_vm.summaryVP.idProtocoloCanc))])]) : _c('p', {
    staticClass: "title-doc-left"
  }, [_vm._v(" ")]), _vm._v(" "), _c('p', {
    staticClass: "title-doc-right",
    class: {
      credit: _vm.summaryVP.idProtocoloCanc
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "box-doc-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold upper"
  }, [_vm._v(_vm._s(_vm.summaryVP.rota) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.summaryVP.origem) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.summaryVP.destino) + " ")])])]), _vm._v(" "), (_vm.summaryVP.categoriaVolta != null) ? _c('div', {
    staticClass: "row row-date"
  }, [_vm._m(8), _vm._v(" "), _vm._m(9)]) : _vm._e(), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "box-doc-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.summaryVP.tag) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold upper"
  }, [_vm._v(_vm._s(_vm.summaryVP.placaVeiculo) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 text-right"
  }, [(_vm.summaryVP.categoriaVolta == null) ? _c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Categoria Veículo:")]) : _c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Categoria Veículo (Ida):")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.summaryVP.categoria) + " ")])]), _vm._v(" "), (_vm.summaryVP.categoriaVolta != null) ? _c('div', [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm.summaryVP.categoriaVolta) + " ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.startVP)) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(_vm._s(_vm._f("dateTime")(_vm.summaryVP.expirationVP)) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20 break"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table receipt"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("PRAÇAS DE PEDÁGIO")]), _vm._v(" "), (_vm.summaryVP.categoriaVolta == null) ? [_c('th', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("CONCESSIONÁRIA")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("VALOR (R$)")])] : [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("CONCESSIONÁRIA")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("FLUXO")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("VALOR (R$)")])]], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryVP.pracas), function(s, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(s.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(s.concessionaria))]), _vm._v(" "), (s.fluxo != null && _vm.summaryVP.categoriaVolta != null) ? _c('td', [_vm._v(_vm._s(s.fluxo))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(s.price)))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [(_vm.summaryVP.categoriaVolta == null) ? _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("TOTAL")]) : _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.summaryVP.valorVP)))])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row hidden-print"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "margin-t20"
  }, [_c('div', {
    staticClass: "back-button-box"
  }, [_c('button', {
    staticClass: "btn btn-back",
    on: {
      "click": function($event) {
        return _vm.window.history.back()
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n              Voltar\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons-box"
  }, [_c('a', {
    attrs: {
      "href": '/api/v2/vp/comprovante/pdf/' + _vm.summaryVP.idIntern,
      "target": "_blank"
    }
  }, [_vm._m(17)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "logo-receipt",
    attrs: {
      "src": require("../../../../static/logo-move-mais-balance-header.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "title-receipt"
  }, [_vm._v("comprovante de emissão de vale-pedágio")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Emissor:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("CNPJ Emissor:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Transportador:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("CPF/CNPJ Transportador:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', [_vm._v("Rota:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Origem:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Destino:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-date"
  }, [_c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-date"
  }, [_c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "three-dots bold"
  }, [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', [_vm._v("N° TAG:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Placa Veículo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Categoria Veículo (Volta):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Data Início VP:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('p', {
    staticClass: "three-dots"
  }, [_vm._v("Data Expiração VP:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("\n                Salvar PDF\n                "), _c('i', {
    staticClass: "icon-pdf align-icon-right-white"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-7493b28c!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/toll-ticket/receipt.vue
// module id = 2170
// module chunks = 1